import { Box, TextField } from '@mui/material';
import { GridApiRef, GridRenderEditCellParams } from '@mui/x-data-grid-pro';
import { format } from 'date-fns';
import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import { LocalizationProvider, DesktopTimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
  },
  inputValTime: {
    height: 15,
    width: 60,
    fontSize: 15,
  },
}));

interface TimePickerEditCellProps {
  apiRef: GridApiRef;
  onTimePickerEdit?: (time: string) => void;
  disabled?: boolean;
}

export function TimePickerEditCell(
  props: TimePickerEditCellProps & GridRenderEditCellParams,
) {
  const { id, field, value, apiRef, disabled = false } = props;
  const classes = useStyles();
  const [error, setError] = useState(false);
  const [selectedDate] = useState(
    value && value !== '' ? `1-1-2022 ${value}` : '',
  );

  const doUpdateCellValue = (newTime: string) => {
    apiRef.current.setEditCellValue({ id, field, value: newTime });
    props.onTimePickerEdit?.(newTime);
  };

  const handleChange = React.useCallback(doUpdateCellValue, []);

  return (
    <Box className={classes.root}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DesktopTimePicker
          value={selectedDate === '' ? null : selectedDate}
          onChange={(date, value?: string) => {
            if (date && date.toString() !== 'Invalid Date') {
              if (value && /^([01]\d|2[0-3]):([0-5]\d)$/.test(value)) {
                const dt = new Date(date);
                const newDt = format(dt, 'HH:mm');
                handleChange(newDt);
                setError(false);
              } else {
                setError(true);
              }
            } else if (date == null) {
              handleChange('');
              setError(false);
            } else {
              setError(true);
            }
          }}
          ampm={false}
          mask="__:__"
          inputFormat="HH:mm"
          disableOpenPicker={true}
          OpenPickerButtonProps={{
            disabled: true,
            style: { display: 'none' },
          }}
          disabled={disabled}
          renderInput={(params) => (
            <TextField
              {...params}
              autoFocus
              placeholder="00:00"
              InputProps={{
                ...params.InputProps,
                classes: { input: classes.inputValTime },
                disableUnderline: true,
                maxRows: 1,
              }}
              error={Boolean(params.error) || error}
              helperText={params.error || error ? 'Invalid' : ''}
              variant="standard"
            />
          )}
        />
      </LocalizationProvider>
    </Box>
  );
}
